import React, { useContext, useState, useEffect } from 'react';
import axios from 'axios';

import { loginApi, logoutApi, questionCategory } from '../';
import { LoadingSpinner } from '../../components/elements';
import Swal from 'sweetalert2';

const AuthContext = React.createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export default function AuthProvider({ children }) {
  const [isLogin, setIsLogin] = useState(false);
  const [loading, setLoading] = useState(true);

  function login(userData, loginSource, setShowLoginModal) {
    // this method is Promise (async)
    // --bisa diganti dengan auth backend sendiri--

    setLoading(true);
    axios
      .post(loginApi, userData, {
        headers: {
          'Content-Type': 'application/json',
        },
        cancelToken: loginSource.token,
      })
      .then((response) => {
        // setAuthToken(response.data.token);
        console.log('hasil login', response);
        console.log('get_cookie', response.headers['set-cookie']);
        Swal.fire({
          title: 'Success!',
          text: response.data.msg,
          icon: 'success',
          confirmButtonColor: '#006CB7',
        });

        setIsLogin(true);
        setLoading(false);
        setShowLoginModal(false);
      })
      .catch((error) => {
        if (error.response) {
          console.log('res', error.response); // => the response
          Swal.fire({
            title: 'Failed!',
            text: error.response.data,
            icon: 'error',
            confirmButtonColor: '#006CB7',
          });
        } else {
          Swal.fire({
            title: 'Failed!',
            text: error.message,
            icon: 'error',
            confirmButtonColor: '#006CB7',
          });
        }

        setIsLogin(false);
        setLoading(false);
      });
  }

  function logout() {
    // this method is Promise (async)
    // --bisa diganti dengan auth backend sendiri--

    setLoading(true);
    axios
      .post(logoutApi)
      .then((response) => {
        document.cookie =
          'auth_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        console.log('hasil logout', response);
        console.log('logout sukses');

        Swal.fire({
          title: 'Success!',
          text: 'Logout success!',
          icon: 'success',
          confirmButtonColor: '#006CB7',
        });
        // history.push('/');

        setIsLogin(false);
        setLoading(false);
      })
      .catch((error) => {
        if (error.response) {
          console.log('res', error.response); // => the response
          Swal.fire({
            title: 'Failed!',
            text: error.response.data,
            icon: 'error',
            confirmButtonColor: '#006CB7',
          });
        } else {
          Swal.fire({
            title: 'Failed!',
            text: error.message,
            icon: 'error',
            confirmButtonColor: '#006CB7',
          });
        }
        console.log('res', error); // => the response payload
        // console.log('res', error.response.message); // => the response payload
        // error.response.data && console.log('res data', error.response.data); // => the response payload
        Swal.fire({
          title: 'Failed!',
          text: 'Logout Failed.',
          icon: 'error',
          confirmButtonColor: '#006CB7',
        });

        setIsLogin(true);
        setLoading(false);
      });
  }

  useEffect(() => {
    // try-catch akan dijalankan saat refresh page dijalankan
    // kode ini akan mengecek sedang login/tidak saat refresh page dgn cara mengirim request ke backend

    // get data category
    axios
      .get(questionCategory)
      .then((response) => {
        // response for category
        if (+response.status === 200) {
          setIsLogin(true);
          console.log('berhasil question category');
        } else {
          setIsLogin(false);
        }

        setLoading(false);
        console.log('isLogin status', response.status);
      })
      .catch((error) => {
        // print error to console
        if (error.response) {
          console.log('data useeffect', error.response.data);
          console.log('isLogin', error.response.status);
        }
        console.log('msg useeffect', error.message);
        console.log('statusCode useeffect', error.status);

        setIsLogin(false);
        setLoading(false);
      });
  }, []);

  const value = {
    isLogin,
    login,
    logout,
  };

  return (
    <AuthContext.Provider value={value}>
      {loading && <LoadingSpinner />}
      {!loading && children}
    </AuthContext.Provider>
  );
}
